<template>
	<!-- 图像验证码 -->
	<div id="captcha-mask" v-if="visible">
		<div id="captcha-div"></div>
	</div>
</template>

<script>
	export default {
		name: 'TAC',
		data() {
			return {
				visible: false,
				resolve: null,
				reject: null
			}
		},
		methods: {
			show() {
				this.visible = true;
				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;

					this.$nextTick(() => {
						this.initCaptcha();
					});
				});
			},

			initCaptcha() {
				const baseURL = process.env.NODE_ENV === "development" ? '/api' : 'https://virus.9itsg.net'
				const captchaConfig = {
					// 请求验证码接口
					requestCaptchaDataUrl: `${baseURL}/api/gen?type=CURVE3`,
					// 验证验证码接口
					validCaptchaUrl: `${baseURL}/api/check`,
					// 绑定的div
					bindEl: "#captcha-div",
					// 验证成功回调函数
					validSuccess: (res, c, t) => {
						// 销毁验证码
						t.destroyWindow();
						this.handleSuccess(res.data.token);
					},
					btnCloseFun: () => {
						this.handleCancel();
					}
				}

				if (typeof window.loadTAC !== 'function') {
					this.handleError(new Error('TAC SDK Not loaded'));
					return;
				}

				window.loadTAC('/tac', captchaConfig)
					.then(tac => tac.init())
					.catch(err => {
						this.handleError(err);
					});

			},
			handleSuccess(token) {
				this.visible = false;
				this.resolve && this.resolve(token); // 返回 token
			},

			handleCancel() {
				this.visible = false;
				this.reject && this.reject(new Error('User cancels verification'));
			},

			handleError(err) {
				this.visible = false;
				this.reject && this.reject(err);
			}
		},
	}
</script>

<style scoped>
	#captcha-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.53);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}
</style>